export const IRIDESCENCE_LIGHT = [0.55, 0.9, 1];
export const IRIDESCENCE_DARK = [0.92, 0.32, 0.12];
